'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleProptype = require('react-style-proptype');

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

var _reactDock = require('react-dock');

var _reactDock2 = _interopRequireDefault(_reactDock);

var _hamburger = require('./shapes/hamburger');

var _colors = require('./colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Drawer = function (_React$Component) {
  _inherits(Drawer, _React$Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.hideDrawer = function () {
      _this.props.onRequestHide && _this.props.onRequestHide();
    }, _this.handleVisibleChange = function () {
      if (_this.props.closeOnClickOutside) {
        _this.hideDrawer();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Drawer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!this.props.show) {
        document.body.className = document.body.className.replace(/ ?drawer-open/, '');
      } else if (this.props.show && !prevProps.show) {
        document.body.className += document.body.className.length ? ' drawer-open' : 'drawer-open';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // clean up any open drawer classes from the body before unmounting the component
      document.body.className = document.body.className.replace(/ ?drawer-open/, '');
    }

    // this is only called when clicking outside the drawer

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          position = _props.position,
          autoResize = _props.autoResize,
          size = _props.size,
          header = _props.header,
          footer = _props.footer,
          children = _props.children,
          headerStyle = _props.headerStyle,
          footerStyle = _props.footerStyle,
          bodyStyle = _props.bodyStyle,
          style = _props.style,
          className = _props.className,
          zIndex = _props.zIndex;


      var customHeader = void 0;
      if (header) {
        customHeader = _react2.default.isValidElement(header) ? header : _react2.default.createElement(
          'h2',
          null,
          header
        );
      }
      var drawerHeader = _react2.default.createElement(
        'div',
        { className: 'drawer-header', style: headerStyle },
        _react2.default.createElement(
          'button',
          { className: 'close', onClick: this.hideDrawer },
          _react2.default.createElement(_hamburger.Close, { width: '18px', color: _colors.granite.base, cropped: true })
        ),
        customHeader
      );

      var drawerFooter = footer && _react2.default.createElement(
        'div',
        { className: 'drawer-footer', style: footerStyle },
        footer
      );

      // don't allow any other values
      var drawerPosition = position || 'right';

      var drawerNode = _react2.default.createElement(
        _reactDock2.default,
        {
          fluid: autoResize,
          size: size,
          position: drawerPosition,
          isVisible: show,
          dimMode: 'opaque',
          zIndex: zIndex,
          dimStyle: { background: 'rgba(0, 0, 0, 0.5)' },
          onVisibleChange: this.handleVisibleChange
        },
        _react2.default.createElement(
          'div',
          { className: 'drawer-content ' + (className || ''), style: style },
          drawerHeader,
          _react2.default.createElement(
            'div',
            { className: 'drawer-body', style: bodyStyle },
            children
          ),
          drawerFooter
        )
      );

      return _reactDom2.default.createPortal(drawerNode, document.body);
    }
  }]);

  return Drawer;
}(_react2.default.Component);

exports.default = Drawer;


Drawer.propTypes = {
  show: _propTypes2.default.bool.isRequired,
  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
  autoResize: _propTypes2.default.bool,
  size: _propTypes2.default.number,
  header: _propTypes2.default.node,
  footer: _propTypes2.default.node,
  children: _propTypes2.default.node,
  closeOnClickOutside: _propTypes2.default.bool,
  onRequestHide: _propTypes2.default.func,
  headerStyle: _reactStyleProptype2.default,
  footerStyle: _reactStyleProptype2.default,
  bodyStyle: _reactStyleProptype2.default,
  style: _reactStyleProptype2.default,
  className: _propTypes2.default.string,
  zIndex: _propTypes2.default.number
};

Drawer.defaultProps = {
  position: 'right',
  autoResize: true,
  size: 0.3,
  zIndex: 1040
};